export default __webpack_public_path__ + "bfx/static/media/icon-VENUES.772a4352.svg";